import { render, staticRenderFns } from "./BannerPageView.vue?vue&type=template&id=558c6c26&scoped=true&"
import script from "./BannerPageView.vue?vue&type=script&lang=js&"
export * from "./BannerPageView.vue?vue&type=script&lang=js&"
import style0 from "./BannerPageView.vue?vue&type=style&index=0&id=558c6c26&lang=scss&rel=stylesheet&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558c6c26",
  null
  
)

export default component.exports